import { render, staticRenderFns } from "./stationDispatch.vue?vue&type=template&id=d4676c36&scoped=true&"
import script from "./stationDispatch.vue?vue&type=script&lang=js&"
export * from "./stationDispatch.vue?vue&type=script&lang=js&"
import style0 from "./stationDispatch.vue?vue&type=style&index=0&id=d4676c36&prod&lang=css&"
import style1 from "./stationDispatch.vue?vue&type=style&index=1&id=d4676c36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4676c36",
  null
  
)

export default component.exports